import { round } from 'Root/helpers/tools';

// eslint-disable-next-line import/prefer-default-export
export function currencyGetPriceWithCommision(basePrice, commissionPercent, precision = 2) {
  return round(+basePrice / (1 - commissionPercent / 100), precision);
}
